<template>
  <div>
    <div class="applySuccss" v-if="info.flag!=4">
      <img src="../../assets/img/detail_image_fail.png" alt />
      <p>审核中</p>
      <p>平台将会与您联系，有疑问可联系平台客服</p>
      <p>
        平台客服：<a href="tel:0752-2162293" v-if="$store.getters.ambientType!=1">0752-2162293</a><a v-else @click="dialPhone('0752-2162293')">0752-2162293</a>
      </p>
    </div>
    <div class="applyFail" v-else>
      <img src="../../assets/img/fail.png" alt />
      <p>审核不通过</p>
      <p>审核不通过原因:{{info.failReason}}</p>
    </div>
    <div class="applyInfo">
      <div class="flex-between">
        <span>绑定社区:</span>
        <span>{{info.shopName}}</span>
      </div>
      <div class="flex-between">
        <span>姓名:</span>
        <span>{{info.name}}</span>
      </div>
      <div class="flex-between">
        <span>联系手机号：</span>
        <span>{{info.mobile}}</span>
      </div>
      <div class="flex-between">
        <span>详细地址：</span>
        <span>{{info.address}}</span>
      </div>
    </div>
    <van-button class="btn" text="编辑信息" block @click="goToRegister" v-if="info.flag==4" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: {},
    };
  },
  methods: {
    dialPhone(phone) {
      window.Android.dialPhone(phone);
    },
    goToRegister() {
      delete this.info.flag;
      delete this.info.failReason;
      this.$router.replace({
        name: "applyRegister",
        path: "/applyRegister",
        params: {
          info: JSON.stringify(this.info),
        },
      });
    },
  },
  mounted() {
    this.info = JSON.parse(this.$route.params.info);
  },
};
</script>

<style lang="scss" scoped>
.applySuccss,
.applyFail {
  width: 100%;
  min-height: 100px;
  padding: 50px 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  font-size: 16px;
  img {
    width: 65px;
    height: 65px;
    display: block;
  }
  p:nth-child(2) {
    font-size: 19px;
    font-weight: 800;
    margin-top: 10px;
  }
}
.applySuccss {
  p:nth-child(2) {
    color: #83ce35;
  }
  p:nth-child(3) {
    margin-top: 4px;
  }
  p:nth-child(4) {
    margin-top: 2px;
    a {
      color: #1993ff;
    }
  }
}
.applyFail {
  p:nth-child(2) {
    color: #ff1310;
  }
  p:nth-child(3) {
    width: 256px;
    margin: 10px auto 0;
  }
}
.applyInfo {
  margin: 0 10px;
  padding: 10px 5px;
  font-size: 16px;
  background-color: #f4f4f4;
  .flex-between {
    align-items: inherit;
    &:not(:last-child) {
      margin-bottom: 5px;
    }
  }
  span:first-child {
    flex: 0 0 106px;
  }
  span:last-child {
    flex: 1;
  }
}
.btn {
  width: 355px;
  height: 50px;
  position: fixed;
  left: 10px;
  bottom: 10px;
  background: linear-gradient(
    90deg,
    rgba(251, 106, 74, 1) 0%,
    rgba(255, 8, 8, 1) 100%
  );
  font-size: 19px;
  color: #ffffff;
  border-radius: 25px;
}
</style>